import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Bill } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EditableCellContent } from "@design-system/ViewTable/EditableCellContent";
import { Amount } from "@design-system/Amount/Amount";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { BillsViewCallbacks } from "../types";

export const AmountCell = memo(
    ({ row, table }: CellContext<ViewTableFeatures, Bill, number>) => {
        const bill = row.original;
        const { callbacks } = useViewTableMeta<BillsViewCallbacks, unknown>(
            table,
        );

        return (
            <ViewTableCell captureClicks>
                <EditableCellContent
                    onClick={() => callbacks?.onBillClick?.(bill)}
                    readonly
                >
                    <Amount amount={bill.total} />
                </EditableCellContent>
            </ViewTableCell>
        );
    },
);
